import React, { Component } from 'react';
import { connect } from 'react-redux';

import { createPlan, deletePlan, } from 'actions/storylet';

import Buttonlet from 'components/Buttonlet';
import { IBranch } from "types/storylet";
import { IAppState } from 'types/app';

export interface OwnProps {
  branch: IBranch,
  dispatch: Function,
  playerHasMaximumActivePlans: boolean,
}

type Props = OwnProps & ReturnType<typeof mapStateToProps>;

interface State {
  isSubmitting: boolean,
}

class PlanButtonlet extends Component<Props, State> {
  static displayName = 'PlanButtonlet';

  state = {
    isSubmitting: false,
  };

  /**
   * Plan branch
   * @return {[type]}          [description]
   * @param branchData
   */
  planBranch = async (branchData: any) => {
    // TODO: use something other than an alert here
    const { dispatch, playerHasMaximumActivePlans } = this.props;
    if (playerHasMaximumActivePlans) {
      alert('Unfortunately, you already have the maximum number of active plans.'); // eslint-disable-line no-alert
      return;
    }
    this.setState({ isSubmitting: true });
    await dispatch(createPlan(branchData));
    this.setState({ isSubmitting: false });
  };

  /**
   * Delete plan
   * @param  {[type]} branchId [description]
   * @return {[type]}          [description]
   */
  deletePlan = async (branchId: number) => {
    const { dispatch } = this.props;
    this.setState({ isSubmitting: true });
    await dispatch(deletePlan(branchId));
    this.setState({ isSubmitting: false });
  };

  render() {
    const { activePlans, branch } = this.props;
    const { isSubmitting } = this.state;

    const isBranchPlanned = !!activePlans.find(plan => plan.branch.id === branch.id);
    // If the user currently has this branch as an active plan,
    // show it as active
    if (isBranchPlanned) {
      return (
        <Buttonlet
          type="plan--active"
          title="Remove this choice from your plans"
          onClick={() => this.deletePlan(branch.id)}
          disabled={isSubmitting}
        />
      );
    }

    // If the user has planned and completed this branch,
    // render a restart option
    if (branch.planState === 'Complete') {
      return (
        <Buttonlet
          type="check"
          title="You have completed this plan; click to restart it"
          onClick={() => this.planBranch(branch)}
          disabled={isSubmitting}
        />
      );
    }

    // Render a mark-as-plan option
    return (
      <Buttonlet
        type="plan"
        title="Mark this choice as a plan"
        onClick={() => this.planBranch(branch)}
        disabled={isSubmitting}
      />
    );
  }
}

const mapStateToProps = ({ plans: { activePlans } }: IAppState) => ({ activePlans });

export default connect(mapStateToProps)(PlanButtonlet);